import * as React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

const Markdown = props => (
  <ReactMarkdown className={props.className} data-placeholder={props['data-placeholder']}>
    {props.value || ''}
  </ReactMarkdown>
)

Markdown.propTypes = {
  className: PropTypes.string,
  'data-placeholder': PropTypes.string,
  value: PropTypes.string,
}

export default Markdown
